import { AnyAction, combineReducers, configureStore } from "@reduxjs/toolkit";
import { createSelectorHook, useDispatch } from "react-redux";
import { AuthReducer } from "./slices/authSlice";

const RootReducer = combineReducers({ auth: AuthReducer });

type ReducerParams = Parameters<typeof RootReducer>;
type ReducerReturn = ReturnType<typeof RootReducer>;

const ActionAppTypeResetStore = "RESET_APP_REDUX_STORE";

export const ActionApp = {
  ResetStore: (): AnyAction => ({ type: ActionAppTypeResetStore }),
};

const AppReducer = (...arg: ReducerParams): ReducerReturn => {
  const [, action] = arg;
  if (action.type === ActionAppTypeResetStore) {
    localStorage.clear();
    return RootReducer(undefined, action);
  }
  return RootReducer(...arg);
};

export const WtaPublisherAppStore = configureStore({
  reducer: AppReducer,
  devTools: process.env.NODE_ENV !== "production",
});

export type WtaPublisherAppState = ReturnType<typeof RootReducer>;
export type WtaPublisherAppDispatch = typeof WtaPublisherAppStore.dispatch;
export const useAppDispatch = () => useDispatch<WtaPublisherAppDispatch>();
export const useAppSelector = createSelectorHook();
